"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientRender = clientRender;
Object.defineProperty(exports, "getVideoPlayerProps", {
  enumerable: true,
  get: function get() {
    return _VideoPlayerProps.getVideoPlayerProps;
  }
});
exports.default = exports.EmbedPlayerModal = exports.VideoPlayer = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _base = require("modals/base");

var _trackObjectView = babelHelpers.interopRequireDefault(require("trackObjectView"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _clapprHlsFix = require("clappr-hls-fix");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _VideoPlayerProps = require("./VideoPlayerProps");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp, _class3, _descriptor5, _descriptor6, _temp2, _class5, _descriptor7, _temp3;

var ActivePlayer = null;
var ClapprPlayer = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ClapprPlayer, _Component);

  function ClapprPlayer() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ClapprPlayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ClapprPlayer)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "player", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onEnded", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onStarted", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "trackPath", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.clapprInstance = null;
    _this.clapprPromise = null;
    _this.playerRoot = null;
    _this.lastRange = {
      start: 0,
      end: 0
    };
    _this.trackInterval = null;
    _this.startedPlayback = false;
    return _this;
  }

  babelHelpers.createClass(ClapprPlayer, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.props.className,
        ref: this.gotPlayerRoot
      });
    }
  }, {
    key: "gotPlayerRoot",
    value: function gotPlayerRoot(node) {
      var _this2 = this;

      if (node != this.playerRoot) {
        if (this.clapprPromise) {
          this.clapprPromise.then(function (Player) {
            Player.destroy();
            _this2.clapprPromise = _this2.clapprInstance = null;
          });
        }

        this.clapprPromise = null;
      }

      this.playerRoot = node;

      if (this.playerRoot) {
        var PlayerPromise;

        if (Clappr.HTML5Video.canPlay(this.player.source)) {
          PlayerPromise = _promisePolyfill.default.resolve((0, _clapprHlsFix.getFixedClappr)(this.player)).then(function (Player) {
            Player.on('ended', function () {
              _this2.trigger('sw-playbackComplete');
            });
            return Player;
          });
        } else {
          PlayerPromise = new _promisePolyfill.default(function (resolve) {
            var P = _this2.player.source.split('/');

            P.pop();
            P.push('metadata');
            (0, _fetch.default)(P.join('/')).then(function (value) {
              return value.json();
            }).then(function (value) {
              var X = JSON.parse(JSON.stringify(_this2.player));
              var PQ = X.source;
              var list = [];

              for (var i = 0; i < value.segmentCount; i++) {
                list.push(PQ + '?segment=' + i);
              }

              var sources = list; // list.map(src => ({ source: src, mimeType: 'application/vnd.apple.mpegurl' }));

              var sp = 0;
              X.source = sources[sp];
              var P = (0, _clapprHlsFix.getFixedClappr)(X);
              P._coreFactory._innerCreate = P._coreFactory.create;

              P._coreFactory.create = function () {
                var R = this._innerCreate.apply(this, arguments);

                R.mediaControl.enable = function () {
                  if (this.options.chromeless) return;
                  this.disabled = false;
                };

                return R;
              };

              P.on(Clappr.Events.PLAYER_ENDED, function () {
                sp++;

                if (sources.length > sp) {
                  P.configure({
                    poster: null
                  });
                  P.load(sources[sp]);
                  P.play();
                } else {
                  P.configure({
                    poster: _this2.player.poster
                  });
                  sp = 0;
                  P.load(sources[0]);
                  P.trigger('sw-playbackComplete');
                }
              });
              resolve(P);
            });
          });
        }

        PlayerPromise.then(function (Player) {
          // var Player = getFixedClappr(this.player);
          Player.attachTo(_this2.playerRoot);
          Player.on('play', _this2.videoPlay);
          Player.on('play', function () {
            if (!_this2.startedPlayback) _this2.onStarted();
            _this2.startedPlayback = true;
          });
          Player.on('seek', _this2.videoSeek);
          Player.on('timeupdate', _this2.videoTimeUpdate);
          Player.on('pause', _this2.videoTrack);
          Player.on('ended', _this2.videoTrack);
          Player.on('sw-playbackComplete', function () {
            ActivePlayer = null;

            _this2.onEnded();
          });
          Player.on('stop', _this2.videoTrack);
          $(window).on('unload', _this2.videoTrack);
          _this2.clapprInstance = Player;
        });
        this.clapprPromise = PlayerPromise;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this.clapprPromise) {
        this.clapprPromise.then(function (Player) {
          Player.destroy();
          if (ActivePlayer == Player) ActivePlayer = null;
          _this3.clapprPromise = _this3.clapprInstance = null;
        });
      }

      if (ActivePlayer == this.clapprInstance) {
        ActivePlayer = null;
      }

      this.clapprPromise = this.clapprInstance = null;
    }
  }, {
    key: "videoTrack",
    value: function videoTrack() {
      var r = this.lastRange;

      if (r.start != r.end) {
        if (this.trackPath) {
          var tgt = this.trackPath + '?' + Object.keys(r).map(function (k) {
            return [k, r[k]].map(encodeURIComponent).join('=');
          }).join('&');
          (0, _fetch.default)(tgt).then(function () {});
        }
      }

      this.lastRange = {
        start: r.end,
        end: r.end
      };
    }
  }, {
    key: "videoPlay",
    value: function videoPlay() {
      if (ActivePlayer) {
        if (ActivePlayer != this.clapprInstance) {
          ActivePlayer.pause();
        }
      }

      ActivePlayer = this.clapprInstance;
      clearInterval(this.trackInterval);
      this.trackInterval = setInterval(this.videoTrack, 10 * 1000);
    }
  }, {
    key: "videoSeek",
    value: function videoSeek(tgt) {
      this.videoTrack();
      this.lastRange.start = this.lastRange.end = tgt;
    }
  }, {
    key: "videoTimeUpdate",
    value: function videoTimeUpdate(_ref) {
      var current = _ref.current;
      this.lastRange.end = current;
    }
  }]);
  return ClapprPlayer;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "player", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onEnded", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onStarted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "trackPath", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotPlayerRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotPlayerRoot"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoTrack", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "videoTrack"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoPlay", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "videoPlay"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoSeek", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "videoSeek"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoTimeUpdate", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "videoTimeUpdate"), _class.prototype)), _class);

var VideoPlayerModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(VideoPlayerModal, _ReactModal);

  function VideoPlayerModal(props, trackPath) {
    var _this4;

    babelHelpers.classCallCheck(this, VideoPlayerModal);
    _this4 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(VideoPlayerModal).call(this, 'video-player-modal'));
    _this4.innerWrapper = false;
    _this4.removeOnHide = true;
    _this4.props = props;

    _this4.setComponent(_react.default.createElement(ClapprPlayer, {
      player: props,
      onEnded: _this4.ended,
      trackPath: trackPath,
      className: "video-player-item container"
    }));

    return _this4;
  }

  babelHelpers.createClass(VideoPlayerModal, [{
    key: "title",
    get: function get() {
      return "";
    }
  }]);
  return VideoPlayerModal;
}(_base.ReactModal);

var EmbedPlayer =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(EmbedPlayer, _Component2);

  function EmbedPlayer() {
    babelHelpers.classCallCheck(this, EmbedPlayer);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(EmbedPlayer).apply(this, arguments));
  }

  babelHelpers.createClass(EmbedPlayer, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.props.className,
        dangerouslySetInnerHTML: {
          __html: this.props.player.embedCode
        }
      });
    }
  }]);
  return EmbedPlayer;
}(_react.Component);

var EmbedPlayerModal =
/*#__PURE__*/
function (_ReactModal2) {
  babelHelpers.inherits(EmbedPlayerModal, _ReactModal2);

  function EmbedPlayerModal(props) {
    var _this5;

    babelHelpers.classCallCheck(this, EmbedPlayerModal);
    _this5 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(EmbedPlayerModal).call(this, 'video-player-modal'));
    _this5.innerWrapper = false;
    _this5.removeOnHide = true;
    _this5.props = props;
    if (props.embedLink) _this5.setComponent(_react.default.createElement(EmbedLinkPlayer, {
      src: props.embedLink,
      className: "video-player-item container"
    }));else _this5.setComponent(_react.default.createElement(EmbedPlayer, {
      player: props,
      className: "video-player-item container"
    }));
    return _this5;
  }

  babelHelpers.createClass(EmbedPlayerModal, [{
    key: "title",
    get: function get() {
      return "";
    }
  }]);
  return EmbedPlayerModal;
}(_base.ReactModal);

exports.EmbedPlayerModal = EmbedPlayerModal;
var MediaCache = {};
var EmbedLinkPlayer = (_class3 = (_temp2 =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(EmbedLinkPlayer, _React$Component);

  function EmbedLinkPlayer() {
    var _babelHelpers$getProt2;

    var _this6;

    babelHelpers.classCallCheck(this, EmbedLinkPlayer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(EmbedLinkPlayer)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "src", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "className", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(EmbedLinkPlayer, [{
    key: "getTypeAndId",
    value: function getTypeAndId() {
      // YouTube
      var tmp;

      if (tmp = /^https?:\/\/youtu\.be\/([^\/?]+)/.exec(this.src)) {
        return {
          type: 'youtube',
          id: decodeURIComponent(tmp[1])
        };
      }

      if (tmp = /^https?:\/\/www\.youtube\.com\/watch\?/.exec(this.src)) {
        tmp = /[\?&]v=([^&]+)/.exec(this.src);
        if (tmp) return {
          type: 'youtube',
          id: decodeURIComponent(tmp[1])
        };
      }

      if (tmp = /^https?:\/\/www\.youtube\.com\/embed\/([^\/?]+)/.exec(this.src)) {
        return {
          type: 'youtube',
          id: decodeURIComponent(tmp[1])
        };
      }

      if (/^https?:\/\/vimeo\.com\//.exec(this.src) && (tmp = /\/(\d+)$/.exec(this.src))) return {
        type: 'vimeo',
        id: decodeURIComponent(tmp[1])
      };
      if (/^https?:\/\/vimeo\.com\//.exec(this.src) && (tmp = /\/(\d+)\/[0-9a-f]+$/.exec(this.src))) return {
        type: 'vimeo',
        id: decodeURIComponent(tmp[1])
      };
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var r = this.getTypeAndId();
      if (!r) return null;
      var type = r.type,
          id = r.id;

      switch (type) {
        case 'youtube':
          return _react.default.createElement("div", {
            className: this.className
          }, _react.default.createElement("iframe", {
            width: "800",
            height: "450",
            src: "https://www.youtube.com/embed/".concat(id, "?autoplay=1"),
            frameBorder: "0",
            allow: "autoplay; encrypted-media",
            allowFullScreen: true
          }));

        case 'vimeo':
          return _react.default.createElement("div", {
            className: this.className
          }, _react.default.createElement("iframe", {
            width: "800",
            height: "450",
            frameBorder: "0",
            src: "https://player.vimeo.com/video/".concat(id, "?autoplay=1"),
            allowFullScreen: true,
            allow: "autoplay; encrypted-media"
          }));
      }

      return null;
    }
  }]);
  return EmbedLinkPlayer;
}(_react.default.Component), _temp2), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "src", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var VideoPlayer = (_class5 = (_temp3 =
/*#__PURE__*/
function (_React$Component2) {
  babelHelpers.inherits(VideoPlayer, _React$Component2);

  // @prop asAudioPlayer = false;
  // @prop playInline = false;
  // @prop showThumbnail = false;
  function VideoPlayer(props) {
    var _this7;

    babelHelpers.classCallCheck(this, VideoPlayer);
    _this7 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(VideoPlayer).call(this, props));
    babelHelpers.initializerDefineProperty(_this7, "lazy", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));

    if (!_this7.lazy) {
      _this7.state = Object.assign({
        ready: true
      }, _this7.props);
    } else {
      _this7.state = {
        ready: false,
        position: _this7.lazy.position,
        buttonTitle: _this7.lazy.buttonTitle,
        sendExperience: _this7.lazy.sendExperience,
        asAudioPlayer: _this7.lazy.asAudioPlayer,
        asInlinePlayer: _this7.lazy.asInlinePlayer,
        showThumbnail: _this7.lazy.showThumbnail,
        externalMediaLink: _this7.lazy.externalMediaLink,
        posterSrc: _this7.lazy.posterSrc,
        embeddedVideo: false,
        showExternalMedia: false
      };
    }

    return _this7;
  }

  babelHelpers.createClass(VideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this8 = this;

      if (this.lazy) {
        if (this.lazy.externalMediaLink) {
          this.setState({
            ready: true
          });
        } else {
          if (!MediaCache["".concat(this.lazy.objectApp, ":").concat(this.lazy.objectId)]) {
            MediaCache["".concat(this.lazy.objectApp, ":").concat(this.lazy.objectId)] = new _promisePolyfill.default(function (resolve) {
              (0, _fetch.default)("data/media-player", {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_this8.lazy)
              }).then(function (result) {
                return result.json();
              }).then(function (result) {
                resolve(result);
              });
            });
          }

          MediaCache["".concat(this.lazy.objectApp, ":").concat(this.lazy.objectId)].then(function (data) {
            _this8.setState(Object.assign({
              ready: true
            }, data));
          });
        }
      }

      $(document).on('sitePropsUpdated', this.sitePropsUpdated);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(prevProps) != JSON.stringify(this.props)) {
        this.lazyUpdate();
      }
    }
  }, {
    key: "lazyUpdate",
    value: function lazyUpdate() {
      var _this9 = this;

      this.setState(function () {
        var state = null;

        if (!_this9.lazy) {
          state = Object.assign({
            ready: true
          }, _this9.props);
        } else {
          state = {
            ready: false,
            position: _this9.lazy.position,
            buttonTitle: _this9.lazy.buttonTitle,
            sendExperience: _this9.lazy.sendExperience,
            asAudioPlayer: _this9.lazy.asAudioPlayer,
            asInlinePlayer: _this9.lazy.asInlinePlayer,
            showThumbnail: _this9.lazy.showThumbnail,
            externalMediaLink: _this9.lazy.externalMediaLink,
            posterSrc: _this9.lazy.posterSrc,
            embeddedVideo: false,
            showExternalMedia: false
          };
          if (state.externalMediaLink) state.ready = true;else {
            if (!MediaCache["".concat(_this9.lazy.objectApp, ":").concat(_this9.lazy.objectId)]) {
              MediaCache["".concat(_this9.lazy.objectApp, ":").concat(_this9.lazy.objectId)] = new _promisePolyfill.default(function (resolve) {
                (0, _fetch.default)("data/media-player", {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(_this9.lazy)
                }).then(function (result) {
                  return result.json();
                }).then(function (result) {
                  resolve(result);
                });
              });
            }

            MediaCache["".concat(_this9.lazy.objectApp, ":").concat(_this9.lazy.objectId)].then(function (data) {
              _this9.setState(Object.assign({
                ready: true
              }, data));
            });
          }
        }

        return state;
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.ready) return _react.default.createElement("div", {
        className: this.asAudioPlayer ? 'audio-player-control' : 'video-player-control'
      });

      if (this.state.asInlinePlayer && !this.state.externalMediaLink) {
        return _react.default.createElement("div", {
          className: this.asAudioPlayer ? 'audio-player-control' : 'video-player-control'
        }, _react.default.createElement(ClapprPlayer, {
          player: this.getPlayerProps(),
          onStarted: this.track,
          trackPath: this.state.trackPath
        }));
      }

      if (this.state.showThumbnail) {
        if (this.state.externalMediaLink && this.state.showExternalMedia) {
          return _react.default.createElement("div", {
            className: this.asAudioPlayer ? "audio-player-control embedded-content" : "video-player-control embedded-content"
          }, _react.default.createElement(EmbedLinkPlayer, {
            src: this.state.externalMediaLink
          }));
        }
        /* Fake a Clappr instance so it's styles apply. */


        return _react.default.createElement("div", {
          className: this.asAudioPlayer ? "audio-player-control" : "video-player-control"
        }, _react.default.createElement("div", null, _react.default.createElement("div", {
          "data-player": true,
          tabIndex: "9999",
          style: {
            width: '800px',
            height: '450px'
          }
        }, _react.default.createElement("div", {
          className: "container",
          "data-container": true
        }, _react.default.createElement("div", {
          className: "player-poster clickable",
          onClick: this.showVideo,
          "data-poster": true,
          style: {
            backgroundImage: "url(".concat(this.state.posterSrc, ")")
          }
        }, _react.default.createElement("div", {
          className: "play-wrapper",
          "data-poster": true
        }, _react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 16 16",
          "data-poster": "",
          className: "poster-icon"
        }, _react.default.createElement("path", {
          fill: "#010101",
          d: "M1.425.35L14.575 8l-13.15 7.65V.35z"
        }))), _react.default.createElement("style", {
          className: "clappr-style"
        }, "\n\t\t\t\t\t\t\t\t\t\t.player-poster[data-poster] {\n\t\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\t\tz-index: 998;\n\t\t\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\tbackground-color: #000;\n\t\t\t\t\t\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\t\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\t\t\t\t\t\t\tbackground-position: 50% 50%; \n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.player-poster[data-poster].clickable {\n\t\t\t\t\t\t\t\t\t\t\tcursor: pointer; \n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.player-poster[data-poster]:hover .play-wrapper[data-poster] {\n\t\t\t\t\t\t\t\t\t\t\topacity: 1; \n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.player-poster[data-poster] .play-wrapper[data-poster] {\n\t\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\t\theight: 25%;\n\t\t\t\t\t\t\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\t\t\t\t\t\t\topacity: 0.75;\n\t\t\t\t\t\t\t\t\t\t\t-webkit-transition: opacity 0.1s ease;\n\t\t\t\t\t\t\t\t\t\t\t-moz-transition: opacity 0.1s ease;\n\t\t\t\t\t\t\t\t\t\t\ttransition: opacity 0.1s ease; \n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.player-poster[data-poster] .play-wrapper[data-poster] svg {\n\t\t\t\t\t\t\t\t\t\t\theight: 100%; \n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.player-poster[data-poster] .play-wrapper[data-poster] svg path {\n\t\t\t\t\t\t\t\t\t\t\tfill: #fff; \n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t")), _react.default.createElement("style", {
          className: "clappr-style"
        }, "\n\t\t\t\t\t\t\t\t\t.container[data-container] {\n\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\tbackground-color: black;\n\t\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\t\twidth: 100%; \n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.container[data-container] .chromeless {\n\t\t\t\t\t\t\t\t\t\tcursor: default; \n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t[data-player] * {\n\t\t\t\t\t\t\t\t\t\tmax-width: none;\n\t\t\t\t\t\t\t\t\t\tbox-sizing: inherit;\n\t\t\t\t\t\t\t\t\t\tfloat: none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t[data-player]:not(.nocursor) .container[data-container]:not(.chromeless).pointer-enabled {\n\t\t\t\t\t\t\t\t\t\tcursor: pointer; \n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t")))));
      }

      return _react.default.createElement("div", {
        className: "video-player-button"
      }, _react.default.createElement("button", {
        onClick: this.showVideo,
        "data-button-title": this.state.buttonTitle
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "play_arrow"
      })));
    }
  }, {
    key: "getPlayerProps",
    value: function getPlayerProps() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
      return {
        source: state.videoSrc,
        poster: state.posterSrc,
        width: 800,
        height: 450,
        autoPlay: !state.asInlinePlayer,
        hideMediaControl: !state.asAudioPlayer,
        audioOnly: state.asAudioPlayer,
        disableFullscreen: state.asAudioPlayer
      };
    }
  }, {
    key: "track",
    value: function track() {
      if (this.state.sendExperience) {
        (0, _trackObjectView.default)('catalog', this.state.id, true);
      }
    }
  }, {
    key: "showVideo",
    value: function showVideo() {
      var _this10 = this;

      if (this.state.externalMediaLink) {
        // var M = new EmbedPlayerModal({ embedLink: this.state.externalMediaLink });
        if (this.state.sendExperience) (0, _trackObjectView.default)('catalog', this.state.id, true); // M.show();

        this.setState({
          showExternalMedia: true
        });
        return;
      }

      if (!this.state.ready) {
        if (!MediaCache["".concat(this.lazy.objectApp, ":").concat(this.lazy.objectId)]) {
          MediaCache["".concat(this.lazy.objectApp, ":").concat(this.lazy.objectId)] = new _promisePolyfill.default(function (resolve) {
            (0, _fetch.default)("data/media-player", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(_this10.lazy)
            }).then(function (result) {
              return result.json();
            }).then(function (result) {
              resolve(result);
            });
          });
        }

        MediaCache["".concat(this.lazy.objectApp, ":").concat(this.lazy.objectId)].then(function (data) {
          var M = new VideoPlayerModal(_this10.getPlayerProps(data), data.trackPath);
          M.show();

          if (M.sendExperience) {
            (0, _trackObjectView.default)('catalog', M.id, true);
          }
        });
        return;
      }

      var M = new VideoPlayerModal(this.getPlayerProps(), this.state.trackPath);
      M.show();

      if (this.state.sendExperience) {
        (0, _trackObjectView.default)('catalog', this.state.id, true);
      }
    }
  }, {
    key: "sitePropsUpdated",
    value: function sitePropsUpdated() {
      if (!_reactDom.default.findDOMNode(this)) return;

      if (!document.documentElement.contains(_reactDom.default.findDOMNode(this))) {
        _reactDom.default.unmountComponentAtNode(_reactDom.default.findDOMNode(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('sitePropsUpdated', this.sitePropsUpdated);
    }
  }]);
  return VideoPlayer;
}(_react.default.Component), _temp3), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "lazy", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "track", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "track"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showVideo", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showVideo"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "sitePropsUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "sitePropsUpdated"), _class5.prototype)), _class5);
exports.VideoPlayer = VideoPlayer;

function clientRender(arg, element) {
  _reactDom.default.render(_react.default.createElement(VideoPlayer, arg), element);
}

var _default = VideoPlayer;
exports.default = _default;